<script setup>
import {computed, ref, watch} from 'vue'
import PageContentMobileContentArea from './PageContentMobileContentArea'
import PageContentOrphaned from "./PageContentOrphaned.vue"
import PageContentSections from "./PageContentSections.vue"
import {usePageTemplatesContentAreasStore} from '@/stores/pageTemplatesContentAreas'
import {usePageSectionsStore} from '@/stores/pageSections'

const props = defineProps({
    pageId: Number
})

const pageTemplatesContentAreasStore = usePageTemplatesContentAreasStore()
const pageSectionsStore = usePageSectionsStore()

const pageSections = computed(() => {
    return (pageSectionsStore.items || []).filter(o => o.pageId === props.pageId)
})

const contentAreas = ref([])

watch(
    () => props.pageId,
    async (newPageId) => {
        if (!newPageId) {
            contentAreas.value = []
            return
        }
        contentAreas.value = (await pageTemplatesContentAreasStore.getPagesContentAreas(
            newPageId
        )) || []
    },
    {immediate: true}
)

pageSectionsStore.init()
</script>

<template>
    <div>
        <template v-if="contentAreas?.length">
            <PageContentMobileContentArea
                v-for="(contentArea, index) in contentAreas" :key="contentArea" :page-id="pageId"
                :content-area="contentArea" :content-area-first="index === 0"
                :content-area-last="index === contentAreas.length - 1"
                :content-areas="contentAreas"/>

            <PageContentOrphaned :page-id="pageId" :content-areas="contentAreas" class="mb-3"/>
        </template>
        <PageContentSections v-else-if="pageSections?.length" :page-id="pageId"/>
    </div>
</template>